export async function saveUserConfiguration(
  user_id,
  product,
  productBodyType,
  companyName,
  config_,
  cost,
  Base64Images,
  customFiles,
  submitted = false,
  selectedByUser,
  setSubmittedConfigObj,
) {
  var selectedByUserConfig;

  if (selectedByUser) {
    selectedByUserConfig = {};
    Object.keys(config_).forEach((mainKey) => {
      Object.keys(config_[mainKey]).forEach((secondryKey) => {
        Object.keys(config_[mainKey][secondryKey]).forEach((lastKey) => {
          if (selectedByUser[mainKey][secondryKey][lastKey]) {
            if (!selectedByUserConfig[mainKey])
              selectedByUserConfig[mainKey] = {};
            if (!selectedByUserConfig[mainKey][secondryKey])
              selectedByUserConfig[mainKey][secondryKey] = {};

            selectedByUserConfig[mainKey][secondryKey][lastKey] =
              config_[mainKey][secondryKey][lastKey];
          }
        });
      });
    });
  }

  const url =
    "https://kesxkrclz0.execute-api.us-east-1.amazonaws.com/Testing/configurations";

  const config = selectedByUserConfig ?? config_;
  if (Base64Images) config.screenshots = Base64Images;
  if (customFiles) config.customFiles = customFiles;
  if (cost) config.cost = cost;

  const body = {
    config,
    submitted,
    product,
    productBodyType,
    companyName,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user_id}`, // Add bearer token here
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(
        `Error saving configuration: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    if (submitted) {
      setSubmittedConfigObj({ config_id: data.config_id, config: config });
    }
    return data;
  } catch (error) {
    console.error("Failed to save configuration:", error);
    throw error;
  }
}
